export default "__VITE_ASSET__CIDdj_kh__"